// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.VIEW_REWARD.REWARD_OVERVIEW

export const REWARD_OVERVIEW = {
  TAB_VIEWED: 'overview-tab_viewed',
  PREVIEW_VIEWED: 'overview_preview-viewed'
};
